export default "__VITE_ASSET__CbSbPJyA__"